import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, HttpApiQueryRepository, interpolate } from '@softline/core';
import { SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY } from '../claim-report.api';
import { ClaimReportSalesOrderQueryRow } from '../types/claim-report-document-query';

@Injectable()
export class ClaimReportSalesOrderRepository extends HttpApiQueryRepository<ClaimReportSalesOrderQueryRow> {
  constructor() {
    super(
      inject(ApiDataAccess),
      interpolate(SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY, { documentType: 'SALES_ORDER' })
    );
  }
}
